<template>
  <div>
    <!-- 名称和指数数字 -->
    <span style="margin-right: 4px; font-size: 13px; color: #c3c3c3">{{
      name
    }}</span>
    <span style="font-size: 11px; color: #c3c3c3">{{ val }}</span>
    <span style="font-size: 10px; color: #999">/100</span>

    <!-- 色带 -->
    <div class="index-wrapper">
      <div class="index-content" :style="`width:${width}px`"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['val', 'name'],
  computed: {
    width() {
      return +(this.val / 10).toFixed(0) * 10
    },
  },
}
</script>
<style scoped>
.index-wrapper {
  height: 5px;
  width: 160px;
  background-image: url('./item-index-bg.png');
  background-repeat: no-repeat;
}
.index-content {
  float: left;
  height: 100%;
  background-image: url('./item-index.png');
}
</style>


// WEBPACK FOOTER //
// src/components/screen28896/disease-zone/item-figure.vue